import { api, unwrap } from '../api/client';
import { useAuth } from '../auth/AuthProvider';
import { TokenPanel } from '../components/TokenPanel';
import { Badge, Card, CardBody, CardHeader, DataList, PageHeader } from '../components/ui';
import { ROLE_LABELS } from '../lib/format';

const PERMISSION_LABELS: Record<string, string> = {
  'asset:read': 'Assets ansehen',
  'asset:write': 'Assets pflegen',
  'asset:dispose': 'Verschrotten',
  'asset:delete': 'Fehlerfassungen löschen',
  'attachment:upload': 'Dateien hochladen',
  'attachment:delete': 'Dateien löschen',
  'masterdata:write': 'Mitarbeiter/Standorte pflegen',
  'asset_type:write': 'Asset-Typen pflegen',
  'user:manage': 'Benutzer verwalten',
};

export function AccountPage() {
  const { me } = useAuth();
  return (
    <>
      <PageHeader title="Mein Konto" />
      <div className="space-y-5">
        <Card>
          <CardHeader title={me.display_name} description={me.email} />
          <CardBody className="space-y-4">
            <DataList
              items={[
                ['Rolle', ROLE_LABELS[me.role] ?? me.role],
                ['Angemeldet über', me.auth_method === 'cloudflare_access' ? 'Cloudflare Access (SSO)' : 'API-Token'],
                ['Mitarbeiter', me.employee ? `${me.employee.short_code} – ${me.employee.name}` : null],
              ]}
            />
            <div className="flex flex-wrap gap-1.5">
              {me.permissions.map((p) => (
                <Badge key={p} tone="blue">
                  {PERMISSION_LABELS[p] ?? p}
                </Badge>
              ))}
            </div>
          </CardBody>
        </Card>
        <TokenPanel
          queryKey={['me', 'tokens']}
          description="Für Skripte und Integrationen (Authorization: Bearer ita_…). Tokens haben deine Rechte."
          list={() => unwrap(api.GET('/api/me/tokens'))}
          create={(body) => unwrap(api.POST('/api/me/tokens', { body }))}
          revoke={(id) => unwrap(api.DELETE('/api/me/tokens/{tokenId}', { params: { path: { tokenId: id } } }))}
        />
      </div>
    </>
  );
}
